<template>
	<div>
		<nav class="level">
			<div class="level-left">
				<div class="level-item">
					<p class="subtitle is-3">Details</p>
				</div>
			</div>
		</nav>

		<b-icon icon="arrow-left" size="is-medium"></b-icon>
		<a v-if="school_id >0" class="button is-text" @click="$router.go(-1);">Terug naar overzicht</a>
		<a v-else class="button is-text" href="../">Terug naar overzicht</a>
		<br />
		<br />
		<div class="level">
			<div class="level-left"></div>
		</div>

		<div class="card">
			<header class="card-header">
				<div class="card-header-title">
					<div class="level">
						<div class="level-left">
							<div class="level-item">
								<h4 class="title is-5">Kwalificatie</h4>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div class="content">
				<table>
					<tr>
						<td style="width:10%;">
							<strong>Code</strong>
						</td>
						<td style="border-left: 6px solid #253c7e">{{studies.study_code}}</td>
					</tr>
					<tr>
						<td>
							<b>Naam</b>
						</td>
						<td style="border-left: 6px solid #253c7e">{{studies.name}}</td>
					</tr>
					<tr>
						<td>
							<b>Categorie</b>
						</td>
						<td style="border-left: 6px solid #253c7e">
							<span v-for="item in levels" :key="item.level_id">
								<template v-if="item.tbl_sys_level">{{item.tbl_sys_level.description}}</template>
							</span>
						</td>
					</tr>
					<tr v-if="school_id > 0">
						<td>
							<b>Soort</b>
						</td>
						<td style="border-left: 6px solid #253c7e">
							<span v-for="item in schools" :key="item.funding_id">
								<template v-if="item.tbl_sys_funding">{{item.tbl_sys_funding.name}}</template>
							</span>
						</td>
					</tr>
					<tr v-if="school_id > 0">
						<td>
							<b>Studieduur</b>
						</td>
						<td style="border-left: 6px solid #253c7e">
							<span v-for="item in schools" :key="item.school_id">
								<template>{{item.study_duration}}</template>
							</span>
						</td>
					</tr>
					<tr v-if="school_id > 0">
						<td>
							<b>Instelling</b>
						</td>
						<td style="border-left: 6px solid #253c7e">{{school.name}}</td>
					</tr>
					<tr>
						<td style="width:10%;">
							<strong>Omschrijving</strong>
						</td>
						<td style="border-left: 6px solid #253c7e">{{studies.description}}</td>
					</tr>
					<tr>
						<td style="width:10%;">
							<strong>Sector</strong>
						</td>
						<td style="border-left: 6px solid #253c7e">
							<span v-for="item in sectors" :key="item.sector_id">
								<template v-if="item.tbl_sys_sector">{{item.tbl_sys_sector.name}}</template>
							</span>
						</td>
					</tr>
					<tr>
						<td style="width:10%;">
							<strong>Niveau</strong>
						</td>
						<td style="border-left: 6px solid #253c7e">
							<span v-for="item in levels" :key="item.level_id">
								<template v-if="item.tbl_sys_level">{{stripNiveau(item.tbl_sys_level.name)}}</template>
							</span>
						</td>
					</tr>
					<div class="columns is-invisible" is-size-6 v-if="school_id > 0 && schoolsubjects.length > 0">
						<div class="column is-1">
							<b>Schooljaar :</b>
						</div>
						<div class="column is-size-6">
							<b-field>
								<b-field>
									<b-select v-model="selected_schoolyear">
										<option v-for="item in schoolyear" :key="item.id" :label="item.name" :value="item.id"></option>
									</b-select>
								</b-field>
							</b-field>
						</div>
					</div>
				</table>
				<template v-if="school_id == 0">
					<table>
						<thead>
							<th style="width:25%;">
								<b>Verzorgt door de volgende instellingen</b>
							</th>
							<th style="width:25%;">
								<b>MB</b>
							</th>
							<th>
								<b>Geldig vanaf</b>
							</th>
							<th>
								<b>Geldig tot</b>
							</th>
						</thead>

						<tr v-for="item in schools" :key="item.school_id">
							<td style="width:25%; border-right: 6px solid #253c7e">
								<router-link
									:to="{ name: 'details', params: { id: item.study_id, school_id: item.school_id }}"
								>{{item.tbl_school.name}}</router-link>
							</td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</table>
				</template>
			</div>

			<div class="card-content">
				<div class="columns is-size-6">
					<div class="column">
						<b>Overige documenten</b>
					</div>
					<div class="column">
						<!-- <a :href="Link">{{studies.mb}}</a> -->
					</div>
				</div>
			</div>
		</div>

		<br />
		<div class="card">
			<header class="card-header">
				<div class="card-header-title">
					<!-- <h4
						v-if="school_id > 0 && schoolsubjects.length > 0"
						class="title is-5"
					>Deelkwalificaties {{school.name}} ({{year.name}})</h4>-->
					<h4 class="title is-5">Deelkwalificaties</h4>
				</div>
			</header>

			<div class="card-content">
				<h6 class="subtitle is-4">Verplichte</h6>

				<br />

				<b-table
					:data="subjects"
					:bordered="true"
					:narrowed="true"
					:striped="true"
					:loading="loading"
					:paginated="isPaginated"
					:per-page="perPage"
					:current-page.sync="currentPage"
					:pagination-simple="isPaginationSimple"
					:default-sort-direction="defaultSortDirection"
				>
					<template slot-scope="props">
						<b-table-column
							field="tbl_sys_subject_type.name"
							label="Deelkwalificatie"
						>{{ props.row.tbl_sys_subject_type.name }}</b-table-column>
						<b-table-column
							field="tbl_sys_study.name"
							label="Soort"
							width="450"
						>{{ props.row.tbl_sys_subject_type.tbl_sys_requirement_type.name }}</b-table-column>
					</template>

					<template slot="empty">
						<section class="section">
							<div class="content has-text-grey has-text-centered">
								<p>
									<b-icon icon-pack="far" icon="exclamation" size="is-large"></b-icon>
								</p>
								<p>Geen Deelkwalificaties</p>
							</div>
						</section>
					</template>
				</b-table>

				<br />
				<template v-if="school_id == 0 && subjects_one.length > 0">
					<h6 class="subtitle is-4">Verplichte Keuze</h6>
					<p class="subtitle is-5">{{studies.subject_type_description}}</p>

					<b-table
						:data="subjects_one"
						:bordered="true"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column
								field="tbl_sys_subject_type.name"
								label="Deelkwalificatie"
							>{{ props.row.tbl_sys_subject_type.name }}</b-table-column>
							<b-table-column
								field="tbl_sys_study.name"
								label="Soort"
								width="450"
							>{{ props.row.tbl_sys_subject_type.tbl_sys_requirement_type.name }}</b-table-column>
						</template>

						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation" size="is-large"></b-icon>
									</p>
									<p>Geen Deelkwalificaties</p>
								</div>
							</section>
						</template>
					</b-table>

					<br />
					<template v-if="subjects_two.length > 0">
						<h6 class="subtitle is-5">Vrije Keuze</h6>

						<b-table
							:data="subjects_two"
							:bordered="true"
							:narrowed="true"
							:striped="true"
							:loading="loading"
							:paginated="isPaginated"
							:per-page="perPage"
							:current-page.sync="currentPage"
							:pagination-simple="isPaginationSimple"
							:default-sort-direction="defaultSortDirection"
						>
							<template slot-scope="props">
								<b-table-column
									field="tbl_sys_subject_type.name"
									label="Deelkwalificatie"
								>{{ props.row.tbl_sys_subject_type.name }}</b-table-column>
								<b-table-column
									field="tbl_sys_study.name"
									label="Soort"
									width="450"
								>{{ props.row.tbl_sys_subject_type.tbl_sys_requirement_type.name }}</b-table-column>
							</template>

							<template slot="empty">
								<section class="section">
									<div class="content has-text-grey has-text-centered">
										<p>
											<b-icon icon-pack="far" icon="exclamation" size="is-large"></b-icon>
										</p>
										<p>Geen Deelkwalificaties</p>
									</div>
								</section>
							</template>
						</b-table>
					</template>
				</template>
				<template v-if="school_id > 0 && schoolsubjects.length > 0">
					<h6 class="subtitle is-5">Keuze Deelkwalificaties</h6>
					<p class="subtitle is-5">{{studies.subject_type_requirement}}</p>

					<b-table
						:data="schoolsubjects"
						:bordered="true"
						:narrowed="true"
						:striped="true"
						:loading="loading"
						:paginated="isPaginated"
						:per-page="perPage"
						:current-page.sync="currentPage"
						:pagination-simple="isPaginationSimple"
						:default-sort-direction="defaultSortDirection"
					>
						<template slot-scope="props">
							<b-table-column
								field="tbl_sys_subject_type.name"
								label="Deelkwalificatie"
							>{{ props.row.tbl_sys_subject_type.name }}</b-table-column>
							<b-table-column
								field="tbl_sys_subject_type.tbl_sys_requirement_type..name"
								label="Soort"
								width="450"
							>{{ props.row.tbl_sys_subject_type.tbl_sys_requirement_type.name }}</b-table-column>
						</template>

						<template slot="empty">
							<section class="section">
								<div class="content has-text-grey has-text-centered">
									<p>
										<b-icon icon-pack="far" icon="exclamation" size="is-large"></b-icon>
									</p>
									<p>Geen Kueze Deelkwalificaties</p>
								</div>
							</section>
						</template>
					</b-table>
				</template>
			</div>
		</div>
	</div>
</template>
 <script>
import { API_ROOT } from "../../config";
import Axios from "axios";

import _ from "lodash";
//import Files from "../../assets/Verantwoordingsinformatie.pdf";
var instance = Axios.create({
	baseURL: API_ROOT,
	timeout: 60000
});

export default {
	name: "overzicht",
	props: ["id", "school_id"],
	components: {},
	data() {
		return {
			schoolyear: [],
			year: {},
			selected_schoolyear: 0,
			name: "",
			loading_schoolyear: false,
			studies: {},
			subjects: [],
			subjects_one: [],
			subjects_two: [],
			schoolsubjects: [],
			sectors: [],
			schools: [],
			school: {},
			levels: [],
			columns: [{}],
			columns_one: [{}],
			columns_two: [{}],
			sector_columns: [{}],
			school_columns: [{}],
			toc: [],
			//Link:"http://pepms.ict-caribbean.com/" + this.studies.mb + ".pdf",
			study_toc: [],
			studies_alpha: [],
			isEmpty: false,
			loading: false,
			isPaginated: false,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 10
		};
	},
	created() {
		// fetch the data when the view is created and the data is
		// already being observed
		//his.fetchData();
		this.getStudies(this.id);
		this.getStudySectors(this.id);
		this.getStudiesSchools(this.id);
		this.getStudylevels(this.id);

		if (this.school_id > 0) {
			this.getDeelkwalificaties(this.id);
			this.getSchool(this.school_id);
			this.getSchoolyear(this.id, this.school_id);
			this.selected_schoolyear = 10;
		} else {
			this.getDeelkwalificaties(this.id);
		}

		console.log(this);
		console.log(this.school_id);
	},
	watch: {
		selected_schoolyear(val) {
			console.log(val);
			this.getSchoolDeelkwalificaties(this.id, this.school_id, val);
			this.getyear(val);
		}
	},
	computed: {
		filteredDataObj() {
			return this.schoolyear.filter(option => {
				return option.name.toString().indexOf(this.name) >= 0;
			});
		}
	},
	methods: {
		stripNiveau(str) {
			console.log(_.split(str, " ")[1]);
			return _.split(str, " ")[1];
		},
		selectSchool: function(option) {
			console.log("select school");
			this.selected_schools = option.id;
		},
		clearSchools: function() {
			console.log("Clear this shit");
			this.name = "";
		},
		getyear(id) {
			var self = this;
			instance.get("/schoolyear/single/" + id).then(function(response) {
				console.log(response.data);
				var obj = response.data;
				self.year = obj;
				console.log(self.year);
			});
		},
		getSchoolyear: function(id, school_id) {
			var self = this;
			instance
				.get("/schoolsubjecttype/cohort/" + id, {
					params: {
						school_id: school_id
					}
				})
				.then(function(response) {
					for (let index = 0; index < response.data.length; index++) {
						const element = response.data[index];
						self.schoolyear.push({
							id: element.schoolyear_id,
							name: element.tbl_sys_schoolyear.name
						});
					}

					self.schoolyear = _.uniqBy(self.schoolyear, "id");
				});
		},
		getSchool(id) {
			var self = this;

			instance.get("/school/single/" + id).then(function(response) {
				self.school = response.data;
				console.log("studies ...");
			});
		},
		getStudies(id) {
			var self = this;

			instance.get("/studies/single/" + id).then(function(response) {
				self.studies = response.data;
				console.log("studies ...");
			});
		},
		getStudylevels(id) {
			var self = this;

			instance.get("/controlstudylevel/studies/" + id).then(function(response) {
				self.levels = response.data;
				console.log(self.levels);
				self.loading = false;
			});
		},
		getStudySectors(id) {
			var self = this;

			instance.get("/controlsectorstudy/study/" + id).then(function(response) {
				self.sectors = response.data;

				console.log("Control Study Level fetched...");
				self.loading = false;
			});
		},
		getStudiesSchools(id) {
			var self = this;

			instance.get("/schoolsectorstudy/study/" + id).then(function(response) {
				if (self.school_id > 0) {
					self.schools = _.filter(response.data, ["school_id", self.school_id]);
				} else {
					self.schools = response.data;
				}

				console.log("studies ...");
			});
		},
		getDeelkwalificaties: function(val) {
			var self = this;
			instance
				.get("/controlstudyschooltypesubjecttype/studie/" + val)
				.then(function(response) {
					if (self.school_id > 0) {
						self.subjects = _.filter(response.data, [
							"tbl_sys_subject_type.requirement_type_id",
							3
						]);
					} else {
						self.subjects = _.filter(response.data, [
							"tbl_sys_subject_type.requirement_type_id",
							3
						]);

						self.subjects_two = _.filter(response.data, [
							"tbl_sys_subject_type.requirement_type_id",
							2
						]);

						self.subjects_one = _.filter(response.data, [
							"tbl_sys_subject_type.requirement_type_id",
							1
						]);
					}
				});
		},
		getSchoolDeelkwalificaties: function(id, school_id, schoolyear_id) {
			var self = this;
			instance
				.get("/schoolsubjecttype/school/" + id, {
					params: {
						school_id: school_id,
						schoolyear_id: schoolyear_id
					}
				})
				.then(function(response) {
					self.schoolsubjects = response.data;
				});
		},
		genCharArray(charA, charZ) {
			var a = [],
				i = charA.charCodeAt(0),
				j = charZ.charCodeAt(0);
			for (; i <= j; ++i) {
				a.push({
					key: String.fromCharCode(i),
					href: "#" + String.fromCharCode(i),
					disabled: false
				});
			}
			a.push({ key: "#", href: "", disabled: false });
			return a;
		},
		navigate(destination) {
			this.$router.push({
				path: destination
			});
		}
	}
};
</script>

 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
</style>
